// based on vc-dialog 7.5.5
import DialogWrap from './DialogWrap';
export default DialogWrap;
